import React from 'react';
import ReactECharts from 'components/ThemedECharts';

import { DARK_BLUE, MEDIUM_BLUE, BLUE } from 'constants/colors';
import { DecompEmpilhamento } from 'types/Relatorios/Decomp';

const PALETA = [DARK_BLUE, MEDIUM_BLUE, BLUE]; // tema: cor de dado

interface Props { data: DecompEmpilhamento; }

export default function EmpilhamentoCustosChart({ data }: Props) {
  const option = {
    legend: { data: data.series.map((s) => s.nome) },
    xAxis: { type: 'value', name: data.eixo_x },
    yAxis: { type: 'value', name: data.eixo_y },
    series: data.series.map((s, i) => ({
      name: s.nome,
      type: 'line',
      step: 'end',
      data: s.pontos,
      color: PALETA[i % PALETA.length],
      ...(i === 0 ? {
        markLine: {
          silent: true,
          lineStyle: { color: '#999', type: 'dashed' }, // tema: cor de dado
          label: { position: 'end' },
          data: data.marcadores.map((m) => ({
            xAxis: m.x,
            name: m.label,
            label: { formatter: m.label },
          })),
        },
      } : {}),
    })),
    tooltip: { trigger: 'axis' },
    grid: { left: '10%', right: '15%', containLabel: true },
  };

  return <ReactECharts option={option} style={{ height: 400 }} />;
}
